var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.09013 9.82031C4.09013 10.0277 4.25654 10.1953 4.46279 10.1953H7.53779C7.74404 10.1953 7.91045 10.0277 7.91045 9.82031V7.52344H4.09013V9.82031ZM10.314 1.80469H1.68662C1.39951 1.80469 1.22021 2.11758 1.36435 2.36719L3.95771 6.77344H8.04521L10.6386 2.36719C10.7804 2.11758 10.6011 1.80469 10.314 1.80469Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.87d39f05089a312ed7e64b672c18c2e8.svg";
export { ForwardRef as ReactComponent };